import { render, staticRenderFns } from "./account-question-set.vue?vue&type=template&id=436fe574&scoped=true"
import script from "./account-question-set.vue?vue&type=script&lang=js"
export * from "./account-question-set.vue?vue&type=script&lang=js"
import style0 from "./account-question-set.vue?vue&type=style&index=0&id=436fe574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436fe574",
  null
  
)

export default component.exports